module.exports = __webpack_public_path__ + "static/img/3-4.a7ef46ba.png";